/**
 * @generated SignedSource<<0ca9fc7fc7c90a27ace395d846e0f8ae>>
 * @relayHash 4e3906105f44b4ee5789a45fdd3066ca
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 41a623a81f707cf267afd8d2b7763a90c12f714aef52d56ce5d41a8ba61f97c5

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { SkillsPageQuery } from './SkillsPageQuery.graphql';

const node: PreloadableConcreteRequest<SkillsPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "41a623a81f707cf267afd8d2b7763a90c12f714aef52d56ce5d41a8ba61f97c5",
    "metadata": {},
    "name": "SkillsPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
